import { render, staticRenderFns } from "./special-gifts-contacts.vue?vue&type=template&id=4a507216"
import script from "./special-gifts-contacts.vue?vue&type=script&lang=js"
export * from "./special-gifts-contacts.vue?vue&type=script&lang=js"
import style0 from "./special-gifts-contacts.vue?vue&type=style&index=0&id=4a507216&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VContainer,VImg})
